import React from 'react';
import PropTypes from 'prop-types';

import { StatusBarWrapper } from './css';
import Desktop from './desktop';
import Mobile from './mobile';

import { quoteStatus } from '../../utils/constant';

const StatusBar = ({
  isSendToSRT,
  isVBP,
  isFormTouched,
  isFormValidated,
  isOrderFulfillmentTeam,
  isSalesSupport,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onValidateForm,
  onSendToSRT,
  onSubmitForApproval,
  hidePricing,
  isFieldReset,
  statusQuote
}) => {
  const getPrice = amount => `$${amount.toFixed(2)}`;
  const { approved } = quoteStatus;

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <Desktop
          isSendToSRT={isSendToSRT}
          isVBP={isVBP}
          isFormTouched={isFormTouched || isFieldReset}
          isFormValidated={isFormValidated}
          isOrderFulfillmentTeam={isOrderFulfillmentTeam}
          isSalesSupport={isSalesSupport}
          dueMonthly={getPrice(dueMonthly)}
          dueNow={getPrice(dueNow)}
          onSaveAndExit={onSaveAndExit}
          onDownloadClick={onDownloadClick}
          onProceedClick={onProceedClick}
          onValidateForm={onValidateForm}
          onSendToSRT={onSendToSRT}
          onSubmitForApproval={onSubmitForApproval}
          hidePricing={hidePricing}
          isQuoteApproved={statusQuote === approved}
        />
        <Mobile
          isSendToSRT={isSendToSRT}
          isVBP={isVBP}
          isFormTouched={isFormTouched || isFieldReset}
          isFormValidated={isFormValidated}
          isOrderFulfillmentTeam={isOrderFulfillmentTeam}
          isSalesSupport={isSalesSupport}
          dueMonthly={getPrice(dueMonthly)}
          dueNow={getPrice(dueNow)}
          onSaveAndExit={onSaveAndExit}
          onDownloadClick={onDownloadClick}
          onProceedClick={onProceedClick}
          onValidateForm={onValidateForm}
          onSendToSRT={onSendToSRT}
          onSubmitForApproval={onSubmitForApproval}
          hidePricing={hidePricing}
          isQuoteApproved={statusQuote === approved}
        />
      </div>
    </StatusBarWrapper>
  );
};

StatusBar.propTypes = {
  isVBP: PropTypes.bool.isRequired,
  isSendToSRT: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isOrderFulfillmentTeam: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired,
  dueMonthly: PropTypes.number,
  dueNow: PropTypes.number,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired,
  onSendToSRT: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onSubmitForApproval: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool,
  isFieldReset: PropTypes.bool.isRequired,
  statusQuote: PropTypes.string.isRequired
};

StatusBar.defaultProps = {
  dueMonthly: 0,
  dueNow: 0,
  hidePricing: false
};

export default StatusBar;
